import React from "react";
import { Routes, Route } from "react-router-dom";

import AboutUsInfo from "../Pages/AboutUsInfo";
import Testimonials from "../Pages/Testimonials";
import Team from "../Pages/Team/Team";
import ContactUs from "../Pages/ContactUs";
import Hero from "../comp/Hero";
import CookiePage from "../comp/CookiePage";
import AssuranceSupport from "../Pages/CountriesServices/us/AssuranceSupport";
import BusinessService from "../Pages/CountriesServices/us/BusinessService";
import ProjectServices from "../Pages/CountriesServices/us/ProjectServices";
import GeneralAccounting from "../Pages/CountriesServices/australia/GeneralAccounting";
import SpecialistServices from "../Pages/CountriesServices/australia/SpecialistServices";
import AusProjectServices from "../Pages/CountriesServices/australia/ProjectServices"
import ClientsWeServe from "../Pages/ClientsWeServe";
import TeamNewPage from "../Pages/Team/TeamNewPage";

import AssuranceIndia from "../Pages/CountriesServices/india/AssuranceSupport"
import BusinessIndia from "../Pages/CountriesServices/india/BusinessService"
import ProjectIndia from "../Pages/CountriesServices/india/ProjectServices"
import Insights from "../Pages/Insights";
import InsightCard1 from "../comp/Insights/InsightCard1";
import InsightCard2 from "../comp/Insights/InsightCard2";
import InsightCard3 from "../comp/Insights/InsightCard3";


const MainPages = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Hero />} />
        
        {/* About Us main page */}
        <Route path="/aboutus" element={<AboutUsInfo />} />
        
        {/* About Us dropdown sub-pages */}
        <Route path="/aboutus/team" element={<Team />} />
        <Route path="/aboutus/clients-we-serve" element={<ClientsWeServe />} />
        
        {/* Other main pages */}
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/cookie-policy" element={<CookiePage />} />
        <Route path="/insights" element={<Insights/>} />
        <Route path="/insights/rethinking-finance-part-1" element={<InsightCard1/>} />
        <Route path="/insights/rethinking-finance-part-2" element={<InsightCard2/>} />
        <Route path="/insights/rethinking-finance-part-3" element={<InsightCard3/>} />



        {/* Legacy routes for backward compatibility (optional - you can remove these if not needed) */}
        <Route path="/clients-we-serve" element={<ClientsWeServe />} />
        <Route path="/team" element={<Team />} />

        {/* US Services */}
        <Route path="/us/services/assurance-support" element={<AssuranceSupport/>}/>
        <Route path="/us/services/business-services" element={<BusinessService/>}/>
        <Route path="/us/services/project-services"  element={<ProjectServices/>}/>

        {/* Canada Services */}
        <Route path="/canada/services/assurance-support" element={<AssuranceSupport/>}/>
        <Route path="/canada/services/business-services" element={<BusinessService/>}/>
        <Route path="/canada/services/project-services"  element={<ProjectServices/>}/>

        {/* Australia Services */}
        <Route path="/australia/services/general-accounting" element={<GeneralAccounting/>}/>
        <Route path="/australia/services/specialist-services" element={<SpecialistServices/>}/>
        <Route path="/australia/services/project-services"  element={<AusProjectServices/>}/>

        {/* India Services */}
        <Route path="/india/services/assurance-support" element={<AssuranceIndia/>}/>
        <Route path="/india/services/business-services" element={<BusinessIndia/>}/>
        <Route path="/india/services/project-services"  element={<ProjectIndia/>}/>

        {/* Team specific page */}
        <Route path="/sri-ramamoorti" element={<TeamNewPage/>}/>
      </Routes>
    </>
  );
};

export default MainPages;